// CANONICAL COPY (GH #7115). src/constants/obligations/obl-threat-intelligence-review.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-threat-intelligence-review',
  title: 'Review threat intelligence',
  description:
    'Collect and analyse information relating to information security threats, including feeds from information-sharing forums, critical suppliers and other external sources. Update risk assessments and integrate threat intelligence into event analysis based on the current threat landscape. Auto-satisfied when the Microsoft Defender feed has been synced within 90 days — continuous Defender ingestion constitutes automated threat intelligence collection. Falls back to a published and current threat intelligence procedure when Defender is not connected.',
  category: 'governance',
  scfIds: ['SCF-GOV-007'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    // Tier 1: Defender feed presence proves automated threat intelligence is being
    // continuously ingested. No manual review cadence required when this passes.
    {
      type: 'defender-feed-fresh',
      maxAgeDays: 90,
      description:
        'Microsoft Defender threat feed has been synced within the last 90 days — confirms automated threat intelligence collection is active',
    },
    // Tier 2: Manual path for tenants not using Defender.
    {
      type: 'document-published',
      description: 'Threat intelligence procedure or review log is published',
    },
    { type: 'document-within-sla', description: 'Threat intelligence review is not overdue' },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
